import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from "@nib-components/heading";
import { PrimaryButton, SecondaryButton } from "@nib-components/button";
import { variables } from "@nib-group/chatbot-shared/styles";
import CONTENT from "./CloseChatModal.content";
import * as S from "./CloseChatModal.style";
const CloseChatModal = _ref => {
  let {
    isOpen,
    onConfirm,
    onCancel
  } = _ref;
  return _jsxs(S.Modal, {
    isOpen,
    contentLabel: CONTENT.TITLE,
    onRequestClose: onCancel,
    style: {
      overlay: {
        zIndex: variables.Z_IDX_INLINE_CHAT_WINDOW
      }
    },
    children: [_jsx(Heading, {
      size: 3,
      children: CONTENT.TITLE
    }), _jsxs(S.ButtonContainer, {
      children: [_jsx(PrimaryButton, {
        onClick: onConfirm,
        children: CONTENT.BTN_CONFIRM
      }), _jsx(SecondaryButton, {
        onClick: onCancel,
        children: CONTENT.BTN_CANCEL
      })]
    })]
  });
};
export default CloseChatModal;